import React, { useState, useEffect, useContext, createContext } from 'react'
import i18n from 'live/services/i18n'
import AdminHeader from 'live/components/header/ui/admin/header'
import styled from 'styled-components'
import { TableList } from './TableList'
import { getFiles } from '../api/getFiles'
import SearchBar from './SearchBar'
import AttachmentsModal from './AttachmentsModal'
import { PermissionsContextModel, checkAllPermission } from '../api/permissions'

export const PermissionsContext = createContext<PermissionsContextModel>(checkAllPermission())

const Uploads = () => {
    const [files, setFiles] = useState([])
    const [search, setSearch] = useState('')
    const [permission, setPermission] = useState<PermissionsContextModel>(checkAllPermission())
    const [showAttachmentsModal, setShowAttachmentsModal] = useState(false)
    const onChange = text => {        
        setSearch(text)
    }

    const filterList = list => {
        return list.filter(model => {
            return Object.keys(model).some(key => model[key].toLowerCase().includes(search))
        })
    }
    useEffect(() => {
        setPermission(checkAllPermission())
    }, [window.Live.authorization])
    useEffect(() => getFiles(setFiles), [])

    const fitName = (str, len) => (str.length > len ? str.substr(0, len) + '...' : str)

    return (
        <PermissionsContext.Provider value={permission}>
            <div className="admin-content">
                <div className="admin-inner">
                    <AdminHeader>
                        <h2>{i18n('Uploads')}</h2>
                    </AdminHeader>
                    {/* <div className="admin-body has-padding"> */}
                    <div className="admin-body has-padding" style={{ paddingBottom: '10px' }}>
                        <Text>Click on the name of a file to download it</Text>
                        <div style={{ display: 'flex', gap: '2rem', alignItems: 'center' }}>
                            <AttachmentsModal
                                showModal={showAttachmentsModal}
                                setShowModal={setShowAttachmentsModal}
                                setFilesList={setFiles}
                            />
                            <SearchBar onChange={onChange} value={search} />
                        </div>

                        <TableList files={filterList(files)} setFiles={setFiles} />
                    </div>
                </div>
            </div>
        </PermissionsContext.Provider>
    )
}

export default Uploads

const Text = styled.p`
    margin-bottom: 20px;
    font-style: italic;
    font-size: 14px;
`
